// extracted by mini-css-extract-plugin
export default {"actions":"StatefulCard_actions__tBeU0","content":"StatefulCard_content__1Bkly"};